export default "__VITE_ASSET__Bqn5ioo___"